"use strict";

exports.__esModule = true;
exports.TicketingContext = void 0;
var _TicketingController = require("./TicketingController");
var _Utils = require("../../../Utils");
/**
 * Provides a ticketing context to consumers
 * @component
 */
var TicketingContext = exports.TicketingContext = (0, _Utils.createEnhancedContext)({
  propName: "ticketing",
  defaultController: _TicketingController.TicketingController
});